export default function ({ $auth, route, redirect }) {
    if ($auth.user.features.viewTranslations || !$auth.user.features.canViewTranslations) {
        return redirect('/')
    }

}
